import React, { useState, useEffect } from "react";
import { Modal, Button, Input, message, Form } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import SuccessTableMail from "./SuccessTableMail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const GenreateSuccessSendMailTableModal = ({
  visible,
  onClose,
  id,
  onOk,
  title,
  route,
  name,
  buttonTitle,
}) => {
  const [mailSent, setMailSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [ccmail, setCcmail] = useState([]);
  const [additionalEmail, setAdditionalEmail] = useState("");

  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  /* fetch default CC & template */
  useEffect(() => {
    if (!visible) return;

    axios
      .get(`${apiUrl}/api/setting/getSetting`)
      .then((res) => {
        let ccKey, templateKey;
        if (name === "proposal") {
          ccKey = "proposal_cc";
          templateKey = "proposal_email";
        } else if (name === "invoice") {
          ccKey = "invoice_cc";
          templateKey = "invoice_email";
        } else {
          ccKey = "agreement_cc";
          templateKey = "agreement_email";
        }
        setCcmail(res.data[ccKey] || []);
        form.setFieldsValue({ message: res.data[templateKey] || "" });
      })
      .catch(console.error);
  }, [visible, name]);

  /* CC helpers */
  const handleAddtoCC = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(additionalEmail.trim())) {
      setCcmail((prev) => [...prev, additionalEmail.trim()]);
      setAdditionalEmail("");
    } else {
      message.error("Invalid email");
    }
  };

  const handleRemovefromCC = (email) => {
    setCcmail((prev) => prev.filter((e) => e !== email));
  };

  /* send */
  const handleSendMail = () => {
    form
      .validateFields()
      .then((values) => {
        setLoading(true);
        axios
          .post(`${apiUrl}/api/${name}/${route}/${id}`, {
            to: values.email,
            cc: ccmail,
            message: values.message,
          })
          .then(() => {
            setLoading(false);
            message.success("Mail sent successfully");
            setMailSent(true);
            onOk?.();
          })
          .catch(() => {
            setLoading(false);
            message.error("Failed to send mail");
          });
      })
      .catch(console.error);
  };

  const handleGoTo = () => {
    if (buttonTitle === "Go to Proposal") navigate("/proposal");
    else if (buttonTitle === "Go to Invoice") navigate("/invoice");
    else navigate("/agreement");
  };

  const handleSuccessMailClose = () => setMailSent(false);

  return (
    <>
      <Modal
        visible={visible}
        onCancel={onClose}
        footer={null}
        centered
        width={500}
        closable
        className="acc-modal"
      >
        <div>
          <div className="text-center font-medium text-xl bg-blue-50 p-4 shadow-sm">
            {title}
          </div>

          <div className="px-12 py-4" style={{ backgroundColor: "#F6FAFB" }}>
            <div className="text-center font-medium text-xl mb-5">
              Send Mail
            </div>

            <Form form={form} layout="vertical">
              <Form.Item
                label="Mail ID"
                name="email"
                rules={[{ required: true, message: "Please enter the email" }]}
              >
                <Input
                  type="email"
                  placeholder="Enter the Mail ID of client"
                  className="w-full p-2 border rounded mb-4"
                />
              </Form.Item>

              {/* CC list */}
              <p className="text-gray-600">CC's Mails:</p>
              {ccmail.length > 0 && (
                <p className="text-gray-600 mb-2">
                  {ccmail.map((email) => (
                    <span
                      key={email}
                      className="inline-block text-blue-600 border border-blue-600 px-2 py-1 rounded mr-2 mb-2"
                    >
                      {email}{" "}
                      <span
                        className="text-red-500 cursor-pointer ml-1"
                        onClick={() => handleRemovefromCC(email)}
                      >
                        ×
                      </span>
                    </span>
                  ))}
                </p>
              )}

              {/* add new CC */}
              <div className="flex items-center gap-x-2 mb-2">
                <Input
                  type="email"
                  placeholder="Enter additional CC email"
                  value={additionalEmail}
                  onChange={(e) => setAdditionalEmail(e.target.value)}
                />
                <Button type="primary" size="small" onClick={handleAddtoCC}>
                  + ADD
                </Button>
              </div>

              <p className="text-gray-600 mb-4">
                Note: This mail will be sent to CCs also. You can edit in
                Settings.
              </p>

              <Form.Item
                label="Message"
                name="message"
                rules={[
                  { required: true, message: "Please enter the message" },
                ]}
              >
                <CKEditor
                  editor={ClassicEditor}
                  data={form.getFieldValue("message") || ""}
                  onChange={(_, editor) =>
                    form.setFieldsValue({ message: editor.getData() })
                  }
                />
              </Form.Item>

              <div className="flex justify-center">
                <Button
                  type="primary"
                  loading={loading}
                  onClick={handleSendMail}
                  className="mr-4"
                >
                  Send Mail
                </Button>
                <Button onClick={handleGoTo}>{buttonTitle}</Button>
              </div>
            </Form>
          </div>
        </div>
      </Modal>

      {mailSent && (
        <SuccessTableMail
          visible={mailSent}
          email={form.getFieldValue("email")}
          title={title}
          onCloseSuccess={handleSuccessMailClose}
        />
      )}
    </>
  );
};

export default GenreateSuccessSendMailTableModal;
